import React from 'react';
import { connect } from 'react-redux';
import SideNav from 'components/layout-components/SideNav';
import MobileNav from 'components/layout-components/MobileNav';
import HeaderNav from 'components/layout-components/HeaderNav';
import { Grid, Layout } from 'antd';
import { DIR_LTR, DIR_RTL, SIDE_NAV_WIDTH } from 'constants/ThemeConstant';
import utils from 'utils';
import { ReduxState } from '../../redux/reducers';

const { Content } = Layout;
const { useBreakpoint } = Grid;

interface AppLayoutProps {
  navCollapsed: boolean;
  direction: 'ltr' | 'rtl';
  navMenuContent: React.ReactNode;
  navProfile: React.ReactNode;
  pageHeader: React.ReactNode;
  appView: React.ReactNode;
}

export const AppLayout = ({
  navCollapsed,
  direction,
  navMenuContent,
  navProfile,
  pageHeader,
  appView,
}: AppLayoutProps) => {
  const screens = utils.getBreakPoint(useBreakpoint());
  const isMobile = !screens.includes('lg');
  const isNavSide = true;
  const getLayoutGutter = () => {
    if (isMobile || navCollapsed) {
      return 0;
    }
    return SIDE_NAV_WIDTH;
  };

  const getLayoutDirectionGutter = () => {
    if (direction === DIR_LTR) {
      return { paddingLeft: getLayoutGutter() };
    }
    if (direction === DIR_RTL) {
      return { paddingRight: getLayoutGutter() };
    }
    return { paddingLeft: getLayoutGutter() };
  };

  return (
    <Layout>
      <HeaderNav isMobile={isMobile} navProfile={navProfile} />
      <Layout className="app-container">
        {isNavSide && !navCollapsed && !isMobile ? <SideNav menuContent={navMenuContent} /> : null}
        <Layout className="app-layout" style={getLayoutDirectionGutter()}>
          <div className="app-content d-flex flex-column">
            {pageHeader}
            <Content className="flex-grow-1">{appView}</Content>
            <AppFooter />
          </div>
        </Layout>
      </Layout>
      {isMobile && <MobileNav menuContent={navMenuContent} />}
    </Layout>
  );
};

const FOOTER_HEIGHT = 60;

/**
 * To prevent the Intercom floating button from overlapping with table actions.
 */
const AppFooter = () => {
  return <div style={{ height: FOOTER_HEIGHT }}></div>;
};

const mapStateToProps = ({ theme }: ReduxState) => {
  const { navCollapsed, locale, direction } = theme;
  return { navCollapsed, locale, direction };
};

export default connect(mapStateToProps)(React.memo(AppLayout));
